// /* eslint-disable no-lone-blocks */
// import './CustomMessage.scss';
// import checked from './image/checked.png';
// import cancel from './image/cancel.png';
// // import congrats from './image/congrats.gif';

// type CustomMessageType = {
//   duration?: string;
//   type: 'success' | 'error';
//   content?: string;
// };
// {
//   /* <img class="congrats" src=${congrats} alt="gif" /> */
// }
// export const CustomMessage = ({
//   type,
//   content,
//   duration,
// }: CustomMessageType) => {
//   const fullComponent = `
//     <div id='custom_massage_id' class=custom_message_wrapper ${
//       type === 'success' ? 'success' : type === 'error' ? 'error' : ''
//     }>
//         <div class="custom_message">
//         <div class="custom_message_content">
//           <div class="imgbox">
//             <img src=${
//               type === 'success' ? checked : type === 'error' ? cancel : ''
//             } alt="" class="img" />
//           </div>
//           <div class="title">
//             <h3>${
//               type === 'success' ? 'Success!' : type === 'error' ? 'Error!' : ''
//             }</h3>
//           </div>
//           <p class="para">
//             ${
//               content
//                 ? content
//                 : type === 'success'
//                 ? 'Your process has been complete successfully'
//                 : type === 'error'
//                 ? 'Your process has been failed'
//                 : ''
//             }
//           </p>
//           <button class="message_submit_btn" type="button">
//             <Span id='count'>${duration ? duration : 2}</Span>
//           </button>
//         </div>
//         <div class="progress_bar"></div>
//          </div>
//      </div>
// `;

//   const root = document?.getElementById('root');
//   // Appending Component
//   root?.insertAdjacentHTML('beforeend', fullComponent);

//   const timmer = setInterval(() => {
//     const message = document?.getElementById('custom_massage_id');
//     const count = message?.querySelector('#count');
//     if (count) {
//       const countNumber = Number(count?.textContent);
//       if (countNumber === 1) {
//         clearInterval(timmer);
//         return message?.remove();
//       }
//       const value = String(Number(count?.textContent) - 1);
//       count.textContent = value;
//     }
//   }, 1000);
// };
/* eslint-disable no-lone-blocks */
import './CustomMessage.scss';
import checked from './image/checked.png';
import cancel from './image/cancel.png';

type ToastType = {
  duration?: number; // Changed to number for seconds
  type: 'success' | 'error';
  content?: string;
  title?: string;
};

export const CustomMessage = ({
  type,
  content,
  duration = 3,
  title,
}: ToastType) => {
  const toastHTML = `
    <div id="enhanced_toast_${Date.now()}" class="toast-container ${type}">
      <div class="toast-content">
        <div class="icon-container">
          <img 
            src="${type === 'success' ? checked : cancel}" 
            alt="${type}-icon" 
            class="toast-icon"
          />
          <div class="icon-glow"></div>
        </div>
        
        <div class="message-body">
          <h3 class="toast-title">
            ${title || (type === 'success' ? 'Great Success!' : 'Oops, Error!')}
          </h3>
          <p class="toast-message">
            ${
              content || 
              (type === 'success' 
                ? 'Operation completed successfully!' 
                : 'Something went wrong, please try again.')
            }
          </p>
        </div>

        <button class="close-btn" aria-label="Close toast">
          <svg viewBox="0 0 24 24" class="close-icon">
            <path d="M6 6l12 12M18 6L6 18"/>
          </svg>
        </button>
      </div>
      
      <div class="progress-bar">
        <div class="progress-fill" style="animation-duration: ${duration}s"></div>
      </div>
    </div>
  `;

  // Append to DOM
  const root = document.getElementById('root');
  root?.insertAdjacentHTML('beforeend', toastHTML);

  // Get toast element
  const toast = root?.querySelector(`#enhanced_toast_${Date.now()}`);
  
  // Close button functionality
  const closeBtn = toast?.querySelector('.close-btn');
  const timer = setTimeout(() => toast?.remove(), duration * 1000);

  closeBtn?.addEventListener('click', () => {
    clearTimeout(timer);
    toast?.classList.add('fade-out');
    setTimeout(() => toast?.remove(), 300);
  });

  // Add entrance animation
  requestAnimationFrame(() => {
    toast?.classList.add('slide-in');
  });
};